// extracted by mini-css-extract-plugin
export var cardGroup = "CardGroup-module--cardGroup--a249b";
export var cdsAssistiveText = "CardGroup-module--cds--assistive-text--9af8b";
export var cdsHideFeedback = "CardGroup-module--cds--hide-feedback--b482e";
export var cdsShowFeedback = "CardGroup-module--cds--show-feedback--50aca";
export var cdsSkeleton = "CardGroup-module--cds--skeleton--176f9";
export var cdsVisuallyHidden = "CardGroup-module--cds--visually-hidden--91f2a";